import { render, staticRenderFns } from "./SearchAccountOrUser.vue?vue&type=template&id=0d4b3f2d"
import script from "./SearchAccountOrUser.vue?vue&type=script&lang=js"
export * from "./SearchAccountOrUser.vue?vue&type=script&lang=js"
import style0 from "./SearchAccountOrUser.vue?vue&type=style&index=0&id=0d4b3f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports